export default function TrustStrip() {
  const items = [
    { icon: 'ri-refresh-line', label: 'Updated Every 24 Hours' },
    { icon: 'ri-check-double-line', label: '1000+ Verified Items' },
    { icon: 'ri-group-line', label: 'Community QC Data' },
    { icon: 'ri-scales-line', label: 'Multi-Agent Comparison' },
  ];

  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-6 py-5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {items.map((item) => (
              <div key={item.label} className="flex items-center gap-3 justify-center md:justify-start">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className={`${item.icon} text-accent-600 text-base`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}